/** Traduzioni inglesi: l'italiano, com'è scritto in `t()`, e l'inglese. */
export const EN_CONTINUITA: Record<string, string> = {
  // --- Costanti mostrate con t() dove si usano ------------------------------
  // TIPI (backup.tsx)
  'Spazio di Molo': 'Molo storage',
  'S3 compatibile': 'S3-compatible',
  'Server SFTP': 'SFTP server',
  // ESITO (backup-copertura.tsx, usato anche da instance.tsx)
  'in corso': 'in progress',
  'riuscito': 'succeeded',
  'verificato': 'verified',
  'fallito': 'failed',
  'non leggibile': 'unreadable',
  // PIANI (backup-copertura.tsx)
  'Ogni ora': 'Hourly',
  'Ogni giorno, di notte': 'Daily, at night',
  'Ogni settimana': 'Weekly',
  // ETICHETTA (routes/instances.tsx), con le stesse parole di EN_ISTANZE
  'In creazione': 'Creating',
  'In avvio': 'Starting',
  'Attiva': 'Running',
  'In arresto': 'Stopping',
  'Ferma': 'Stopped',
  'Riavvio': 'Restarting',
  'Modifica in corso': 'Applying changes',
  'Ripristino in corso': 'Restoring',
  'Fallita': 'Failed',
  'In eliminazione': 'Deleting',
  // SEMAFORO, FASE, ESITO_CORSA, ESITO_RIGA (continuita.tsx)
  'Da guardare': 'Needs attention',
  'Non regge': 'Falls short',
  'Non si sa': 'Unknown',
  'Sto creando e installando il server nuovo': 'Creating and installing the new server',
  'Sto scollegando il server perso': 'Disconnecting the lost server',
  'Sto facendo rinascere le istanze': 'Bringing the instances back',
  'Finita': 'Finished',
  'Riuscita': 'Succeeded',
  'Non riuscita': 'Failed',
  'In attesa': 'Waiting',
  'In ripristino': 'Restoring',
  'Risponde': 'Responding',
  'Non tornata': 'Not back',
  'Senza backup': 'No backup',
  // FASI e NOME_FASE (trasloco.tsx, NOME_FASE usato anche da traslochi.tsx)
  'Preparazione': 'Preparation',
  'Prova': 'Test',
  'Trasloco': 'Migration',
  'Controlli': 'Checks',
  'Chiuso': 'Closed',
  'In preparazione': 'Preparing',
  'Prova in corso': 'Rehearsal running',
  'Prova pronta': 'Rehearsal ready',
  'Traslocata': 'Migrated',
  'Annullato': 'Cancelled',

  // --- backup.tsx -----------------------------------------------------------
  'Da ora i nuovi backup vanno qui': 'New backups go here from now on',
  'Nuova destinazione': 'New destination',
  'Non riesco a leggere le destinazioni': 'Couldn’t load the destinations',
  'Nessun posto dove salvare i backup': 'Nowhere to store backups yet',
  'Scegli dove salvarli': 'Choose where to store them',
  "I backup di ogni istanza vanno in uno spazio riservato a questa organizzazione, cifrato con una chiave sua. Finché non c'è una destinazione non si può pianificare nessun backup.":
    'Each instance’s backups go to a space reserved for this organization, encrypted with its own key. Until there is a destination, no backup can be scheduled.',
  'La prova non è partita': 'The test didn’t start',
  'Dove vanno i backup': 'Where backups go',
  'Destinazione': 'Destination',
  'Ultima prova': 'Last test',
  'predefinita': 'default',
  'Usa questa': 'Use this one',
  'Come sono protetti i backup': 'How backups are protected',
  'Cifrati sempre, e nessuno può cancellarli dal server': 'Always encrypted, and nobody can delete them from the server',
  'Ogni backup è cifrato con una chiave che appartiene a questa organizzazione: Molo la custodisce e non la mostra a nessuno. Il server può solo {aggiungere} copie; quella che serve a cancellare le copie vecchie resta a Molo. Così un server compromesso non può distruggere la propria storia.':
    'Every backup is encrypted with a key that belongs to this organization: Molo keeps it and never shows it to anyone. The server can only {aggiungere} copies; the credential that deletes old copies stays with Molo. That way a compromised server can’t destroy its own history.',
  'aggiungere': 'add',
  'Impronta della chiave': 'Key fingerprint',
  'Mai provata': 'Never tested',
  'Non funziona': 'Not working',
  '{nome} è pronta a ricevere backup': '{nome} is ready to receive backups',
  'Uno spazio riservato a questa organizzazione. La chiave che lo cifra la genera Molo e non la mostra a nessuno.':
    'A space reserved for this organization. Molo generates the key that encrypts it and never shows it to anyone.',
  'Preparo…': 'Preparing…',
  'Crea destinazione': 'Create destination',
  'Non è stata creata': 'It wasn’t created',
  'Come vuoi chiamarla, es. «Backup principale».': 'What to call it, e.g. “Main backup”.',
  'Spazio di Molo — consigliato': 'Molo storage — recommended',
  'S3 compatibile (AWS, Scaleway, MinIO…)': 'S3-compatible (AWS, Scaleway, MinIO…)',
  'Servono due credenziali diverse: una per scrivere, una per pulire.': 'Two different credentials are needed: one to write, one to clean up.',
  'Non serve altro: le credenziali le prepara Molo.': 'Nothing else needed: Molo prepares the credentials.',
  'Endpoint S3, poi il bucket e un percorso con il nome dell’organizzazione (stile path, il bucket non va nell’host). Backblaze B2 si usa dal suo endpoint S3.':
    'S3 endpoint, then the bucket and a path with the organization’s name (path style: the bucket doesn’t go in the host). Backblaze B2 is used through its S3 endpoint.',
  'Il percorso deve finire con il nome dell’organizzazione: uno spazio per azienda, mai condiviso.':
    'The path must end with the organization’s name: one space per company, never shared.',
  'Credenziale per scrivere': 'Write credential',
  'Nella forma «chiave:segreto». Va sul server: può scrivere e leggere, non cancellare.':
    'In the form “key:secret”. It goes on the server: it can write and read, not delete.',
  'Va sul server: può aggiungere backup, non cancellarli.': 'It goes on the server: it can add backups, not delete them.',
  'Credenziale per pulire': 'Cleanup credential',
  'Nella forma «chiave:segreto», con accesso pieno al bucket. Resta a Molo.':
    'In the form “key:secret”, with full access to the bucket. It stays with Molo.',
  'Resta a Molo: elimina i backup scaduti e li verifica.': 'It stays with Molo: it deletes expired backups and verifies them.',
  'Come si prepara un bucket in sola aggiunta': 'How to set up an append-only bucket',
  'La credenziale del server ha bisogno di scrivere, leggere ed elencare il bucket, e di cancellare {solo} sotto {locks}: è dove restic mette il proprio lucchetto durante un backup e lo toglie alla fine. Su AWS, MinIO e simili è una policy come questa, con il nome del bucket e del percorso al posto dei segnaposto:':
    'The server credential needs to write, read and list the bucket, and to delete {solo} under {locks}: that’s where restic puts its lock during a backup and removes it at the end. On AWS, MinIO and the like it’s a policy like this one, with the bucket and path names in place of the placeholders:',
  'solo': 'only',
  'Su Backblaze B2, dove le policy non ci sono: una chiave applicativa limitata al bucket {senza} {deleteFiles} per il server, e una con {deleteFiles} per Molo. La prova qui sotto dice se la separazione regge.':
    'On Backblaze B2, which has no policies: an application key restricted to the bucket {senza} {deleteFiles} for the server, and one with {deleteFiles} for Molo. The test below tells you whether the separation holds.',
  'senza': 'without',
  "{ovh}: le policy si importano {sullUtente} (Object Storage → Utenti → «Importa una policy»), senza {principal}: quella qui sopra va bene così com'è, per l'utente del server. L'utente creato dal wizard del container {non} ha permessi pieni: all'utente di Molo serve una policy con {s3} sul bucket, altrimenti la prova si ferma su «Access Denied» al primo passo. Le chiavi si generano con «Abilita Object Storage (S3)» e la secret si rilegge con «Mostra la chiave segreta». L'indirizzo è in stile {path}, con il bucket dopo l'host: {esempio}; quello con il bucket nell'host non funziona.":
    '{ovh}: policies are imported {sullUtente} (Object Storage → Users → “Import a policy”), without {principal}: the one above works as it is, for the server’s user. The user created by the container wizard does {non} have full permissions: Molo’s user needs a policy with {s3} on the bucket, otherwise the test stops at “Access Denied” on the first step. Keys are generated with “Enable Object Storage (S3)” and the secret can be shown again with “Show secret key”. The address is {path}-style, with the bucket after the host: {esempio}; the one with the bucket in the host doesn’t work.',
  'Su OVH Object Storage': 'On OVH Object Storage',
  "sull'utente": 'on the user',
  'non': 'not',
  'https://s3.<regione>.io.cloud.ovh.net/<bucket>/<organizzazione>': 'https://s3.<region>.io.cloud.ovh.net/<bucket>/<organization>',
  'Le due credenziali sono identiche': 'The two credentials are identical',
  'Se il server potesse anche cancellare, un server compromesso cancellerebbe i propri backup. Servono due credenziali diverse.':
    'If the server could also delete, a compromised server would delete its own backups. Two different credentials are needed.',

  // --- backup-copertura.tsx -------------------------------------------------
  'Non pianificati': 'Not scheduled',
  'Personalizzata ({cron})': 'Custom ({cron})',
  'Le tue istanze': 'Your instances',
  'Una istanza senza backup automatici': 'One instance without automatic backups',
  '{n} istanze senza backup automatici': '{n} instances without automatic backups',
  'Non riesco a leggere la copertura': 'Couldn’t load backup coverage',
  'Nessuna istanza': 'No instances',
  "Quando creerai un'istanza, qui vedrai se ha i backup e di quando è l'ultimo.":
    'Once you create an instance, you’ll see here whether it has backups and when the latest one was taken.',
  'Backup automatici': 'Automatic backups',
  'Ultimo backup': 'Latest backup',
  'Prova di ripristino': 'Restore test',
  'Rimossa · era su {server}': 'Removed · was on {server}',
  'Ripristina': 'Restore',
  'Gestisci': 'Manage',
  'Mai fatto': 'Never taken',
  'verificato {quando}': 'verified {quando}',
  'Mai provato': 'Never tested',
  'Si ricarica': 'Restores',
  'Non si ricarica': 'Doesn’t restore',
  'Sto ripristinando in {nome}': 'Restoring into {nome}',
  'Sto riportando {nome} al backup': 'Rolling {nome} back to the backup',
  'Backup di {nome}': 'Backups of {nome}',
  'Ripristina {nome} come copia': 'Restore {nome} as a copy',
  'Riporta {nome} al backup': 'Roll {nome} back to the backup',
  'L’istanza non c’è più, i suoi backup sì: da uno di questi rinasce, sul server che scegli.':
    'The instance is gone, but its backups aren’t: it can be brought back from one of them, on the server you choose.',
  'Il backup diventa un’istanza nuova, sul server che scegli. L’originale non viene toccata.':
    'The backup becomes a new instance, on the server you choose. The original isn’t touched.',
  'I dati attuali vengono sostituiti da quelli del backup, nella stessa istanza. Prima ne viene fatta una copia di sicurezza.':
    'The current data is replaced with the backup’s, in the same instance. A safety copy is taken first.',
  'Indietro': 'Back',
  'Sostituisci i dati': 'Replace the data',
  '{nome} — quello dell’originale': '{nome} — the original’s',
  'Backup avviato: lo vedi comparire qui sotto': 'Backup started: it will appear below',
  'Provo a ricaricare l’ultimo backup di {nome}': 'Trying to restore the latest backup of {nome}',
  'Backup fatti': 'Backups taken',
  'Prova il ripristino': 'Test the restore',
  'Fai un backup adesso': 'Back up now',
  'Il backup non è partito': 'The backup didn’t start',
  'Non riesco a leggere i backup': 'Couldn’t load the backups',
  'Nessun backup, ancora': 'No backups yet',
  'Di questa istanza non esiste nessuna copia. Fanne uno adesso, oppure attiva quelli automatici qui sopra.':
    'There’s no copy of this instance. Take one now, or turn on automatic backups above.',
  'A mano': 'Manual',
  'Automatico': 'Automatic',
  'Backup in corso': 'Backup in progress',
  'ricaricato con successo {quando}': 'restored successfully {quando}',
  'non si ricarica: {errore}': 'doesn’t restore: {errore}',
  'Scarica': 'Download',
  'Come copia': 'As a copy',
  'In produzione': 'In production',
  'Backup automatici di {nome}: {piano}': 'Automatic backups for {nome}: {piano}',
  'Backup automatici di {nome} disattivati': 'Automatic backups for {nome} turned off',
  'Attivi': 'On',
  'Non attivi': 'Off',
  'Non sono riuscito a salvare': 'Couldn’t save',
  'Non sono riuscito a disattivarli': 'Couldn’t turn them off',
  'Ogni quanto': 'How often',
  'Personalizzata…': 'Custom…',
  'Regola': 'Rule',
  'Nel formato cron, cinque colonne: es. «0 3 * * *» per le tre di notte.': 'In cron format, five fields: e.g. “0 3 * * *” for 3 a.m.',
  'Quante copie tenere': 'How many copies to keep',
  'Orarie': 'Hourly',
  'Giornaliere': 'Daily',
  'Settimanali': 'Weekly',
  'Mensili': 'Monthly',
  'Quante copie conservare per ciascun periodo; le più vecchie vengono eliminate da Molo. Lasciando zero valgono i valori consigliati: 24 orarie, 7 giornaliere, 4 settimanali, 12 mensili.':
    'How many copies to keep for each period; Molo deletes the older ones. Leave zero to use the recommended values: 24 hourly, 7 daily, 4 weekly, 12 monthly.',
  'Disattiva': 'Turn off',
  'Il ripristino non è partito': 'The restore didn’t start',
  'Dal backup del {data}': 'From the backup of {data}',
  "Nasce un'istanza nuova con i dati di {origine}.": 'A new instance is created with the data of {origine}.',
  "Nasce un'istanza nuova accanto a {origine}, che resta accesa e intatta.": 'A new instance is created next to {origine}, which stays up and untouched.',
  'La copia parte {sicura}: niente email in uscita, niente operazioni automatiche — così una copia di produzione non manda fatture ai clienti veri.':
    'The copy starts {sicura}: no outgoing email, no scheduled actions — so a copy of production doesn’t send invoices to real customers.',
  'in modalità sicura': 'in safe mode',
  "La copia ha bisogno di un server che abbia finito l'installazione. Collegane uno e aspetta che diventi «Pronto».":
    'The copy needs a server that has finished installing. Connect one and wait for it to become “Ready”.',
  'Dove nasce la copia. Il backup sta nella destinazione dell’azienda, non sul server: può rinascere su qualunque macchina pronta, anche se quella originale non c’è più.':
    'Where the copy is created. The backup lives in the company’s destination, not on the server: it can be brought back on any ready machine, even if the original one is gone.',
  'Nome della copia': 'Copy name',
  'Solo minuscole, cifre e trattini, a partire da una lettera o una cifra.': 'Lowercase letters, digits and hyphens only, starting with a letter or a digit.',
  'Es. «{nome}-test». Non si cambia più.': 'E.g. “{nome}-test”. It can’t be changed later.',
  'I dati di {istanza} tornano al {data}': 'The data of {istanza} goes back to {data}',
  'Tutto ciò che è stato fatto dopo quel momento sparisce da {istanza}: ordini, fatture, allegati. Prima di toccare qualcosa viene fatto un backup di sicurezza dei dati attuali, e Odoo resta acceso finché i dati nuovi non sono pronti. Le sessioni aperte vengono chiuse.':
    'Everything done after that moment disappears from {istanza}: orders, invoices, attachments. Before anything is touched, a safety backup of the current data is taken, and Odoo stays up until the new data is ready. Open sessions are closed.',
  'Scrivi il nome dell’istanza per confermare': 'Type the instance name to confirm',
  'Scrivi «{nome}».': 'Type “{nome}”.',

  // --- continuita.tsx -------------------------------------------------------
  'Runbook copiato: incollalo dove lo ritrovi quando l’hub non c’è': 'Runbook copied: paste it somewhere you can find it when the hub is down',
  'Continuità': 'Continuity',
  'Il server è perso': 'The server is lost',
  'Non riesco a leggere la prontezza': 'Couldn’t load the readiness status',
  'Corsa in corso': 'Run in progress',
  '{cosa} per {perso} → {destinazione}: {fase}.': '{cosa} ({perso} → {destinazione}): {fase}.',
  'Esercitazione in corso': 'Drill in progress',
  '{fatte} di {totale} istanze rispondono.': '{fatte} of {totale} instances are responding.',
  'Siamo pronti?': 'Are we ready?',
  'Obiettivi: RTO {rto} · RPO {rpo} · hub {hub}': 'Targets: RTO {rto} · RPO {rpo} · hub {hub}',
  'Cosa': 'What',
  'Vai': 'Go',
  'È successo qualcosa': 'Something happened',
  'Un server è perso': 'A server is lost',
  'Le sue istanze rinascono dall’ultimo backup su un altro server, {stesso}. Il server perso viene scollegato, poi un lavoro fa tutto il resto e cronometra.':
    'Its instances come back from the latest backup on another server, {stesso}. The lost server is disconnected, then a job does the rest and times it.',
  'con lo stesso nome e lo stesso indirizzo': 'with the same name and the same address',
  'Un’istanza è danneggiata': 'An instance is damaged',
  'Si riportano i dati a un backup nella stessa istanza (con una copia di sicurezza prima), o si fa una copia accanto per guardare senza toccare.':
    'Roll the data back to a backup in the same instance (with a safety copy first), or make a copy alongside to look without touching anything.',
  'Vai ai backup': 'Go to backups',
  'L’hub è perso': 'The hub is lost',
  'Il pannello non può ricostruire sé stesso: la procedura, con i valori di questa installazione, va tenuta {fuori}. Le istanze intanto continuano a girare.':
    'The panel can’t rebuild itself: the procedure, with this installation’s values, must be kept {fuori}. Meanwhile the instances keep running.',
  'fuori di qui': 'outside of it',
  'Copia il runbook': 'Copy the runbook',
  'Il runbook «l’hub è perso», com’è adesso': 'The “hub is lost” runbook, as it stands now',
  'Esercitazioni ed esecuzioni': 'Drills and runs',
  'Ogni sei mesi almeno una. La scheda dei tempi si compila da sola.': 'At least one every six months. The timing sheet fills itself in.',
  'Nessuna corsa ancora': 'No runs yet',
  '«Il server è perso» in modalità di prova non tocca l’originale: le copie nascono con il suffisso -dr, si verificano, si tolgono. È il modo di sapere che il piano regge prima che serva.':
    '“The server is lost” in drill mode doesn’t touch the original: the copies are created with the -dr suffix, checked, then removed. It’s how you know the plan holds before you need it.',
  'Esercitazione': 'Drill',
  'Ripristino': 'Restore',
  '{fatte} di {totale} istanze': '{fatte} of {totale} instances',
  'Obiettivi salvati: i semafori si misurano contro questi': 'Targets saved: the status lights are measured against these',
  'Obiettivi di ripristino': 'Recovery targets',
  'Quello che si promette ai clienti di questa organizzazione. I semafori qui sopra si misurano contro questi numeri.':
    'What this organization promises its customers. The status lights above are measured against these numbers.',
  'Non salvati': 'Not saved',
  'RTO — minuti per tornare su': 'RTO — minutes to be back up',
  'Da quando si dichiara il disastro a quando l’ultima istanza risponde. 240 sono quattro ore.':
    'From when the disaster is declared to when the last instance responds. 240 is four hours.',
  'RPO — minuti di dati che si possono perdere': 'RPO — minutes of data that can be lost',
  'L’età massima dell’ultimo backup. Con 60, ogni istanza vuole una pianificazione oraria.':
    'The maximum age of the latest backup. With 60, every instance needs an hourly schedule.',
  'Esercitazione: il server è perso': 'Drill: the server is lost',
  'Come il disastro vero, senza toccare niente: le copie nascono con il suffisso -dr accanto alle istanze vere, si verificano e poi si tolgono a mano.':
    'Like the real disaster, without touching anything: the copies are created with the -dr suffix next to the real instances, checked, then removed by hand.',
  'Il server perso viene scollegato da Molo e le sue istanze rinascono dall’ultimo backup sul server che scegli, con lo stesso nome e lo stesso indirizzo.':
    'Molo disconnects the lost server and its instances come back from the latest backup on the server you choose, with the same name and the same address.',
  'Avvia l’esercitazione': 'Start the drill',
  'Dichiara il disastro': 'Declare the disaster',
  'Non avviata': 'Not started',
  'È un’esercitazione: non toccare l’originale': 'It’s a drill: don’t touch the original',
  'Server perso': 'Lost server',
  'Nessuna istanza su questo server': 'No instances on this server',
  'Un’istanza rinasce': 'One instance comes back',
  '{n} istanze rinascono': '{n} instances come back',
  '{nomi}. Ognuna dall’ultimo backup riuscito: un’istanza senza backup resta indietro, e la scheda lo dice.':
    '{nomi}. Each from its latest successful backup: an instance without a backup is left behind, and the report says so.',
  'Non c’è niente da far rinascere: scollegalo dalla sua scheda, se serve.': 'There’s nothing to bring back: disconnect it from its page, if needed.',
  'Nessun server pronto su cui rinascere': 'No ready server to come back on',
  'Collega un server nuovo (il one-liner di bootstrap: il provisioning va da solo in dieci minuti) e torna qui. Con un progetto OVH collegato in Impostazioni, da qui si crea da solo.':
    'Connect a new server (the bootstrap one-liner: provisioning runs on its own in ten minutes) and come back here. With an OVH project connected in Settings, it’s created from here automatically.',
  'Dove rinascono': 'Where they come back',
  'Un server nuovo su OVH, creato adesso': 'A new server on OVH, created now',
  'La corsa crea la macchina, aspetta i suoi passi di installazione (circa dieci minuti) e poi ripristina.':
    'The run creates the machine, waits for its installation steps (about ten minutes), then restores.',
  'Un server pronto dell’organizzazione. Il backup sta nella destinazione, non sulla macchina persa.':
    'A ready server in the organization. The backup lives in the destination, not on the lost machine.',
  'Nome del server nuovo': 'New server name',
  'Solo minuscole, cifre e trattini. È anche il nome della macchina su OVH.': 'Lowercase letters, digits and hyphens only. It’s also the machine’s name on OVH.',
  'L’IP fisso {ip} resta dov’è': 'The static IP {ip} stays where it is',
  'Eredita l’IP fisso {ip}': 'Inherits the static IP {ip}',
  'In esercitazione l’indirizzo della produzione non si sposta: la copia risponde sull’IP della macchina nuova.':
    'In a drill the production address doesn’t move: the copy answers on the new machine’s IP.',
  'Il server nuovo si porta dietro l’indirizzo: nessun DNS da aspettare. Scegli una regione della stessa zona (GRA, SBG e RBX stanno insieme).':
    'The new server takes the address with it: no DNS to wait for. Choose a region in the same zone (GRA, SBG and RBX go together).',
  'Scrivi il nome del server perso per confermare': 'Type the lost server’s name to confirm',
  'Scrivi «{nome}». Viene scollegato: Molo dimentica come entrarci e toglie i nomi delle sue istanze.':
    'Type “{nome}”. It will be disconnected: Molo forgets how to get in and removes its instances’ names.',
  'Scheda dei tempi copiata in Markdown': 'Timing sheet copied as Markdown',
  'Dichiarato {quando}': 'Declared {quando}',
  'Copia la scheda': 'Copy the timing sheet',
  'Corsa non leggibile': 'Couldn’t load the run',
  'Non tutte le istanze sono tornate': 'Not all instances came back',
  'Tutte le istanze rispondono': 'All instances are responding',
  'Verifica le copie -dr (login, conteggi, allegati), poi rimuovile dalla loro scheda.':
    'Check the -dr copies (login, counts, attachments), then remove them from their page.',
  'I clienti ritrovano i loro indirizzi. Controlla i certificati dalle schede delle istanze.':
    'Customers find their addresses again. Check the certificates from the instance pages.',
  'T0 · disastro dichiarato': 'T0 · disaster declared',
  'T1 · ultima istanza risponde': 'T1 · last instance responds',
  'RTO misurato': 'Measured RTO',
  'RTO misurato (obiettivo {obiettivo})': 'Measured RTO (target {obiettivo})',
  'RPO misurato': 'Measured RPO',
  'RPO misurato (obiettivo {obiettivo})': 'Measured RPO (target {obiettivo})',
  'Dal backup del': 'From the backup of',
  'Log': 'Log',
  'Apri': 'Open',

  // --- traslochi.tsx --------------------------------------------------------
  'Traslochi': 'Migrations',
  'Collega una macchina CloudPepper': 'Connect a CloudPepper machine',
  'Da CloudPepper a Molo. Colleghi la macchina CloudPepper con una riga da root: Molo ne legge le istanze — versione, moduli, repository, librerie, domini, pesi — e da lì fa la prova, il trasloco vero e spegne l’originale. Sulla macchina non installa niente.':
    'From CloudPepper to Molo. You connect the CloudPepper machine with one command as root: Molo reads its instances — version, modules, repositories, libraries, domains, sizes — and from there runs the rehearsal, the real migration, and shuts down the original. It installs nothing on the machine.',
  'Non riesco a leggere le macchine': 'Couldn’t load the machines',
  'Macchine CloudPepper': 'CloudPepper machines',
  'Nessuna macchina collegata. Si comincia da qui: una per ogni server CloudPepper da cui portare via le istanze.':
    'No machines connected. Start here: one for each CloudPepper server you want to move instances off.',
  'aspetto che la riga venga eseguita sulla macchina': 'waiting for the command to run on the machine',
  '1 istanza': '1 instance',
  '{n} istanze': '{n} instances',
  'letta {quando}': 'read {quando}',
  'Collegata': 'Connected',
  'Riga scaduta': 'Command expired',
  'Aspetto la riga': 'Waiting for the command',
  'Collega {nome}': 'Connect {nome}',
  'Molo ci entra con un utente suo, ne legge le istanze e non ci installa niente.':
    'Molo logs in with its own user, reads the instances and installs nothing.',
  'Guarda le istanze': 'See the instances',
  'Non l’ho collegata': 'Couldn’t connect it',
  'Come la chiami qui. Minuscole, cifre e trattini.': 'What you call it here. Lowercase letters, digits and hyphens.',
  'L’IP o il nome con cui Molo la raggiunge in SSH.': 'The IP or name Molo uses to reach it over SSH.',
  'Molo è entrato in {host} e ha trovato 1 istanza.': 'Molo logged in to {host} and found 1 instance.',
  'Molo è entrato in {host} e ha trovato {n} istanze.': 'Molo logged in to {host} and found {n} instances.',
  'Entra come {root} su {host} e incolla questa riga entro quindici minuti. Crea l’utente {utente}, gli autorizza la chiave di Molo e nient’altro: la macchina resta di CloudPepper.':
    'Log in as {root} on {host} and paste this command within fifteen minutes. It creates the {utente} user, authorizes Molo’s key for it and nothing else: the machine stays CloudPepper’s.',
  'La riga non si mostra una seconda volta': 'The command isn’t shown a second time',
  'Chiedine una nuova qui sotto.': 'Ask for a new one below.',
  'Non ho un comando nuovo': 'Couldn’t get a new command',
  'Comando nuovo': 'New command',
  'Entrato: leggo le istanze…': 'Logged in: reading the instances…',
  'Aspetto che la riga venga eseguita…': 'Waiting for the command to run…',
  'Rileggo la macchina': 'Re-reading the machine',
  'Macchina dimenticata': 'Machine forgotten',
  'Macchina CloudPepper': 'CloudPepper machine',
  'Torna ai traslochi': 'Back to migrations',
  'Non riesco a leggere la macchina': 'Couldn’t load the machine',
  'Non l’ho riletta': 'Couldn’t re-read it',
  'Cose che non ho potuto leggere': 'Things I couldn’t read',
  'Sulla macchina non c’è nessuna istanza di CloudPepper.': 'There are no CloudPepper instances on this machine.',
  'Scollega {nome}': 'Disconnect {nome}',
  'Molo toglie dalla macchina l’utente molo-trasloco e la sua chiave. CloudPepper e le istanze restano come sono.':
    'Molo removes the molo-trasloco user and its key from the machine. CloudPepper and the instances stay as they are.',
  'Dimenticala': 'Forget it',
  'Non l’ho scollegata': 'Couldn’t disconnect it',
  '«Dimenticala» è per una macchina che non c’è più: Molo non la tocca e toglie solo la sua chiave.':
    '“Forget it” is for a machine that no longer exists: Molo doesn’t touch it and only removes its key.',
  'Accesa': 'Running',
  'Spenta': 'Stopped',
  'Database {db} · allegati {allegati} · {moduli}': 'Database {db} · attachments {allegati} · {moduli}',
  'Non si trasloca': 'Not migrated',
  'Così non si trasloca': 'Can’t be migrated as it is',
  'ramo {ramo}': 'branch {ramo}',
  '(nessuno: commit staccato)': '(none: detached commit)',
  'cartella {cartella}': 'folder {cartella}',
  'senza git: nel trasloco dici da quale repository viene': 'no git: in the migration you say which repository it comes from',
  'Librerie Python in più: {librerie}': 'Extra Python libraries: {librerie}',
  'Traslocata in {nome}': 'Migrated to {nome}',
  'Apri il trasloco': 'Open the migration',
  'Trasloca…': 'Migrate…',
  'porta {porta}': 'port {porta}',
  'Trasloca {nome}': 'Migrate {nome}',
  'Si apre il trasloco: niente si spegne e niente si copia finché non lo decidi tu, passo per passo.':
    'This opens the migration: nothing is shut down or copied until you decide, step by step.',
  'Crea il server e apri il trasloco': 'Create the server and open the migration',
  'Prima crea o collega il server su cui portarla, dalla pagina dei server. Con un progetto OVH collegato in Impostazioni, lo crei da qui.':
    'First create or connect the server to move it to, from the servers page. With an OVH project connected in Settings, you can create it from here.',
  'Server di destinazione': 'Destination server',
  'Molo compra la macchina e la installa (circa dieci minuti). Intanto il trasloco si prepara: incolli le chiavi su GitHub, e la prova parte quando il server è pronto.':
    'Molo buys the machine and installs it (about ten minutes). Meanwhile the migration gets ready: you paste the keys on GitHub, and the rehearsal starts when the server is ready.',
  'Nome su Molo': 'Name on Molo',
  'Vuoto: il nome che ha su CloudPepper.': 'Empty: the name it has on CloudPepper.',
  'Non l’ho aperto': 'Couldn’t open it',

  // --- trasloco.tsx ---------------------------------------------------------
  '1 modulo installato': '1 module installed',
  '{n} moduli installati': '{n} modules installed',
  'Trasloco di {nome}': 'Migration of {nome}',
  'Non riesco a leggere il trasloco': 'Couldn’t load the migration',
  'Trasloco annullato': 'Migration cancelled',
  'L’istanza resta su CloudPepper, com’era.': 'The instance stays on CloudPepper, as it was.',
  'Prova in corso: porto il database e gli allegati, poi l’import': 'Rehearsal running: copying the database and attachments, then the import',
  'Trasloco in corso: CloudPepper è spento, porto i dati di adesso': 'Migration running: CloudPepper is off, copying the current data',
  'Torno su CloudPepper': 'Going back to CloudPepper',
  'Trasloco in corso': 'Migration in progress',
  'L’istanza sta nascendo su Molo con i dati di CloudPepper.': 'The instance is being created on Molo with the CloudPepper data.',
  'Al lavoro': 'Working',
  'Segui il trasloco': 'Follow the migration',
  'Segui l’import': 'Follow the import',
  'L’ultimo passo non è andato': 'The last step didn’t go through',
  'Apri il log': 'Open the log',
  'Parte la prova': 'Rehearsal starting',
  'Cosa si porta': 'What’s being moved',
  'database {db} · allegati {allegati}': 'database {db} · attachments {allegati}',
  'Repository dei moduli': 'Module repositories',
  'Su GitHub, per ogni repository: {percorso}, incolla la chiave, lascia la sola lettura. Poi «Verifica»: Molo prova dal server di destinazione che la chiave apra il repository, che il ramo ci sia e che ci siano i moduli installati.':
    'On GitHub, for each repository: {percorso}, paste the key, leave it read-only. Then “Verify”: from the destination server, Molo checks that the key opens the repository, that the branch exists and that the installed modules are there.',
  'Le cartelle senza git — CloudPepper porta sul server il codice senza la storia — chiedono prima da quale repository vengono.':
    'Folders without git — CloudPepper puts the code on the server without its history — first ask which repository they come from.',
  'Non ho verificato': 'Couldn’t verify',
  'Verifica': 'Verify',
  'La prova': 'The rehearsal',
  'Prima, una prova': 'First, a rehearsal',
  'Prova pronta in {durata}': 'Rehearsal ready in {durata}',
  'Apri la prova': 'Open the rehearsal',
  'È il fermo che avrà il cliente il giorno del trasloco.': 'That’s the downtime the customer will have on migration day.',
  'La prova è neutralizzata — cron spenti, posta disattivata — e CloudPepper è ancora acceso: entra con «Entra in Odoo», guarda dati, allegati, report e moduli.':
    'The rehearsal is neutralized — crons off, mail disabled — and CloudPepper is still running: sign in with “Sign in to Odoo”, check data, attachments, reports and modules.',
  'Molo fa il dump con CloudPepper acceso e crea {nome}, neutralizzata. Si guarda che sia tutto al suo posto, e si misura quanto ci vuole.':
    'Molo takes the dump with CloudPepper running and creates {nome}, neutralized. You check that everything is in place, and measure how long it takes.',
  'Prima i repository delle cartelle': 'Folder repositories first',
  'Da collegare: {elenco}.': 'To connect: {elenco}.',
  'Prima le chiavi': 'Keys first',
  'Mancano da verificare: {elenco}.': 'Still to verify: {elenco}.',
  'Non è partita': 'It didn’t start',
  'Non l’ho annullato': 'Couldn’t cancel it',
  'Rifai la prova': 'Redo the rehearsal',
  'Fai la prova': 'Run the rehearsal',
  'Annulla il trasloco': 'Cancel the migration',
  'Il server {nome} non è pronto': 'Server {nome} isn’t ready',
  'Il server {nome} si sta preparando': 'Server {nome} is being prepared',
  'Apri il server': 'Open the server',
  'L’installazione si è fermata: riprendila dalla scheda del server, o annulla il trasloco e aprilo verso un altro.':
    'The installation stopped: resume it from the server page, or cancel the migration and open it toward another server.',
  'Di solito ci vuole una decina di minuti. Intanto incolla le chiavi su GitHub e controlla nome e librerie: «Verifica» e la prova partono quando il server è pronto.':
    'It usually takes about ten minutes. Meanwhile, paste the keys on GitHub and check the name and libraries: “Verify” and the rehearsal start when the server is ready.',
  'Diventa l’indirizzo sotto il dominio dell’organizzazione. Se è quello che CloudPepper usa già, il giorno del trasloco Molo lo sposta da solo.':
    'It becomes the address under the organization’s domain. If CloudPepper already uses it, Molo moves it by itself on migration day.',
  'Salva il nome': 'Save the name',
  'Da collegare': 'To connect',
  'Verificato': 'Verified',
  'Non entra': 'No access',
  'Da verificare': 'To verify',
  'Su CloudPepper sta in {cartella}, senza git.': 'On CloudPepper it lives in {cartella}, without git.',
  'Su CloudPepper sta in {cartella}, senza git: scrivi da quale repository GitHub viene, e con quale ramo.':
    'On CloudPepper it lives in {cartella}, without git: enter which GitHub repository it comes from, and which branch.',
  'Repository su GitHub': 'GitHub repository',
  'git@github.com:<proprietario>/{nome}.git': 'git@github.com:<owner>/{nome}.git',
  'Copia la chiave': 'Copy the key',
  'Usa questo repository': 'Use this repository',
  'Usa questo ramo': 'Use this branch',
  'Quelle installate a mano su CloudPepper e che Odoo non porta, lette dall’ambiente dell’istanza. Togli quelle che non servono più.':
    'The ones installed by hand on CloudPepper that Odoo doesn’t ship, read from the instance’s environment. Remove the ones no longer needed.',
  'Librerie, una per riga': 'Libraries, one per line',
  'Non le ho salvate': 'Couldn’t save them',
  'Salva le librerie': 'Save the libraries',
  'Parte il trasloco': 'Migration starting',
  'Il giorno vero: avvisa il cliente prima.': 'The real day: let the customer know beforehand.',
  'Trasloca adesso': 'Migrate now',
  'Molo {spegne} e la tiene spenta: da qui nessuno ci scrive più.': 'Molo {spegne} and keeps it off: from here on nobody writes to it.',
  'spegne {istanza} su CloudPepper': 'shuts down {istanza} on CloudPepper',
  'Rifà il dump con i dati di adesso e crea {nome} su {server}, {senza}: cron, posta e pagamenti accesi.':
    'It takes the dump again with the current data and creates {nome} on {server}, {senza}: crons, mail and payments on.',
  'senza neutralizzarla': 'without neutralizing it',
  'La prova se ne va.': 'The rehearsal is removed.',
  'Il fermo stimato dalla prova è di {durata}.': 'The downtime estimated by the rehearsal is {durata}.',
  'Se qualcosa va storto, «Torna su CloudPepper» riaccende l’originale e rimette il nome dove puntava.':
    'If something goes wrong, “Go back to CloudPepper” turns the original back on and points the name back where it was.',
  'Non è partito': 'It didn’t start',
  'Riprovo': 'Retrying',
  'L’originale su CloudPepper è spento. Se il motivo è un repository o un modulo, sistemalo e riprova: lo zip è ancora sul server, non si rifà il dump.':
    'The original on CloudPepper is off. If the cause is a repository or a module, fix it and retry: the zip is still on the server, no new dump is needed.',
  'L’originale su CloudPepper è ancora acceso.': 'The original on CloudPepper is still running.',
  'Non è ripartito': 'It didn’t restart',
  'Torna su CloudPepper': 'Go back to CloudPepper',
  'L’istanza su Molo se ne va, il nome torna dove puntava, l’originale si riaccende.':
    'The instance on Molo is removed, the name points back where it was, and the original is turned back on.',
  'Quello che qualcuno ha scritto su Molo dopo il trasloco si perde. Il prossimo tentativo comincia da una prova nuova.':
    'Anything written on Molo after the migration is lost. The next attempt starts from a new rehearsal.',
  'Non sono tornato': 'Couldn’t go back',
  'Non riesco a leggere gli indirizzi': 'Couldn’t load the addresses',
  'L’istanza non aveva indirizzi suoi su CloudPepper.': 'The instance had no addresses of its own on CloudPepper.',
  'Non li ho collegati': 'Couldn’t connect them',
  'Indirizzi controllati': 'Addresses checked',
  'Controlla e collega': 'Check and connect',
  'Avanti ai controlli': 'On to the checks',
  'Non sono andato avanti': 'Couldn’t move on',
  'punta a {indirizzi}': 'points to {indirizzi}',
  'non si risolve': 'doesn’t resolve',
  'TTL {durata}: abbassalo il giorno prima, o il cambio si vedrà tardi': 'TTL {durata}: lower it the day before, or the change will show up late',
  'Sotto il dominio dell’organizzazione: lo sposta Molo creando l’istanza. Adesso {dove}.':
    'Under the organization’s domain: Molo moves it when creating the instance. Right now it {dove}.',
  'Il certificato non è arrivato: {errore}. Quando punta qui, «Controlla e collega» riprova.':
    'The certificate didn’t arrive: {errore}. Once it points here, “Check and connect” tries again.',
  'Il certificato non è arrivato. Quando punta qui, «Controlla e collega» riprova.':
    'The certificate didn’t arrive. Once it points here, “Check and connect” tries again.',
  'Collegato: il certificato sta arrivando.': 'Connected: the certificate is on its way.',
  'Collegato all’istanza, con il suo certificato.': 'Connected to the instance, with its certificate.',
  'Punta già qui: «Controlla e collega» lo collega.': 'Already points here: “Check and connect” connects it.',
  'Punta già al server di destinazione.': 'Already points to the destination server.',
  'Il cliente deve cambiare il record A in {ip}: adesso {dove}{ttl}.': 'The customer must change the A record to {ip}: right now it {dove}{ttl}.',
  'l’IP del server': 'the server’s IP',
  'Non va': 'Not working',
  'Certificato in arrivo': 'Certificate on its way',
  'Punta qui': 'Points here',
  'Lo sposta Molo': 'Molo moves it',
  'Da puntare': 'To be pointed',
  'Backup partito: il controllo diventa verde quando finisce': 'Backup started: the check turns green when it finishes',
  'Trasloco chiuso': 'Migration closed',
  'Cosa ho verificato': 'What I checked',
  'Non riesco a fare i controlli': 'Couldn’t run the checks',
  'Cosa sai solo tu': 'What only you know',
  'Gli utenti entrano con le loro credenziali e trovano i loro dati': 'Users sign in with their credentials and find their data',
  'Le integrazioni funzionano: fatturazione elettronica, banche, pagamenti, posta': 'Integrations work: e-invoicing, banks, payments, mail',
  'Non l’ho registrato': 'Couldn’t record it',
  'Non l’ho chiuso': 'Couldn’t close it',
  'Chiudi il trasloco': 'Close the migration',
  'Blocca': 'Blocking',
  'No': 'No',
  'Perché una push su GitHub arrivi all’istanza, ogni repository vuole il suo webhook. Su GitHub: {percorso}, indirizzo e segreto qui sotto, tipo di contenuto {tipo}. Togli quello di CloudPepper, e la sua deploy key.':
    'For a push on GitHub to reach the instance, each repository needs its own webhook. On GitHub: {percorso}, with the address and secret below and content type {tipo}. Remove CloudPepper’s one, and its deploy key.',
  'Mostra il webhook': 'Show the webhook',
  'Non l’ho generato': 'Couldn’t generate it',
  'Il webhook': 'The webhook',
  'Il segreto si mostra una volta sola: quello di prima non vale più.': 'The secret is shown only once: the previous one no longer works.',
  'Indirizzo copiato': 'Address copied',
  'Copia l’indirizzo': 'Copy the address',
  'Segreto': 'Secret',
  'Segreto copiato': 'Secret copied',
  'Copia il segreto': 'Copy the secret',
  '{nome} è su Molo': '{nome} is on Molo',
  'Apri l’istanza': 'Open the instance',
  'Traslocata il {data}.': 'Migrated on {data}.',
  'Traslocata.': 'Migrated.',
  'Se su CloudPepper c’era una copia di prova, rifalla da qui: «Crea una copia di prova» nella scheda dell’istanza.':
    'If there was a staging copy on CloudPepper, recreate it from here: “Create a staging copy” on the instance page.',
  'Resta da fare fuori da Molo': 'Still to do outside Molo',
  'Cancellare {istanza} dal pannello di CloudPepper: su Molo è spenta e mascherata, ma lì risulta ancora.':
    'Delete {istanza} from the CloudPepper panel: on Molo it’s off and masked, but it still shows up there.',
  'Quando la macchina {macchina} è vuota, scollegarla da {scheda} e dismetterla presso il suo provider.':
    'When the machine {macchina} is empty, disconnect it from {scheda} and decommission it with its provider.',
  'la sua scheda': 'its page',
  // Parole con due sensi: il senso dopo la barra (vedi lib/lingua.tsx).
  'Attiva|azione': 'Enable',
  'Prova|trasloco': 'Rehearsal',
};
